var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatitude(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0H4Z",
    fill: "#5F6877"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 2.90001C5.18345 2.90001 2.9001 5.18335 2.9001 8.00001C2.9001 10.8167 5.18345 13.1 8.0001 13.1C10.8167 13.1 13.1001 10.8167 13.1001 8.00001C13.1001 5.18335 10.8167 2.90001 8.0001 2.90001ZM2.1001 8.00001C2.1001 4.74153 4.74162 2.10001 8.0001 2.10001C11.2586 2.10001 13.9001 4.74153 13.9001 8.00001C13.9001 11.2585 11.2586 13.9 8.0001 13.9C4.74162 13.9 2.1001 11.2585 2.1001 8.00001Z",
    fill: "#9E9DAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96575 4.0674C4.89325 4.68467 6.34266 5.10001 8.0001 5.10001C9.65754 5.10001 11.1069 4.68467 12.0344 4.0674L12.4777 4.73339C11.3879 5.45867 9.77338 5.90001 8.0001 5.90001C6.22681 5.90001 4.61232 5.45867 3.52252 4.73339L3.96575 4.0674Z",
    fill: "#9E9DAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 10.9C6.34805 10.9 4.90252 11.3127 3.97458 11.9268L3.53308 11.2596C4.62265 10.5386 6.23239 10.1 8.0001 10.1C9.7678 10.1 11.3775 10.5386 12.4671 11.2596L12.0256 11.9268C11.0977 11.3127 9.65214 10.9 8.0001 10.9Z",
    fill: "#9E9DAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5001 8.40003L2.5001 8.40003L2.5001 7.60003L13.5001 7.60003V8.40003Z",
    fill: "#9E9DAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatitude);
export default __webpack_public_path__ + "static/media/latitude.234ba761e3d752afc2acb2147b86d5a9.svg";
export { ForwardRef as ReactComponent };